






































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { AppMode } from '@/store/types/app';

import staffData from '@/../public/json/staff.json';

@Component
export default class Staff extends Vue {
  @Getter('mode', { namespace: 'app' }) private mode!: AppMode;
  private staffs = staffData;

  private isInApp (): boolean {
    return this.mode === AppMode.APP;
  }
}
